import React from 'react';
import { Message } from 'semantic-ui-react';

/**
 * Placeholder for the Variation Selector component
 * This will be replaced with the new variationWorksheet implementation
 * 
 * @returns {JSX.Element} VariationSelector component
 */
const VariationSelector = () => {
  return (
    <Message info>
      <Message.Header>Coming Soon</Message.Header>
      <p>
        The Variation Selector feature is currently being reimplemented with an improved architecture.
        This feature will be available in a future update.
      </p>
    </Message>
  );
};

export default VariationSelector;
